import { connect } from 'react-redux';

import RejectDocumentModal from '@app/components/Modal/RejectDocumentModal';
import { modalClose } from '@app/store/modal/actions';
import { getName } from '@app/store/user/user/selectors';

const mapStateToProps = (state) => ({
  userName: getName(state),
});

const mapDispatchToProps = {
  onCancel: modalClose,
};

export default connect(mapStateToProps, mapDispatchToProps)(RejectDocumentModal);
